module.exports = __webpack_public_path__ + "img/top8.780a1a3b.png";